// extracted by mini-css-extract-plugin
export default {"login_bg":"login_login_bg__jx83n","logo_area":"login_logo_area__aQkCF","login_box":"login_login_box__50wBa"};